import { Typography, Box, Button } from "@mui/material";
import React from "react";
import { YouTube } from "@mui/icons-material";
import ReactPlayer from "react-player";

const Info = ({ tournamentData }) => {
  return (
    <Box /////////// wrapper
      sx={{
        display: "flex",
        // alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Typography component="h4" sx={{ fontWeight: "bold", color: "white" }}>
        Description:
      </Typography>

      <Typography component={"p"} sx={{ color: "white" }}>
        {tournamentData.description}
      </Typography>

      {/* ////////////// youtube link  */}

      <Box sx={{ display: "flex", marginTop: "25px", alignItems: "center" }}>
        <Typography component="h4" sx={{ fontWeight: "bold", color: "white" }}>
          Youtube link:
        </Typography>
        <Button
          sx={{ color: "#d93349" }}
          onClick={() => {
            if (tournamentData.yt_link) {
              window.open(tournamentData.yt_link);
            }
          }}
        >
          <YouTube sx={{ height: "40px", width: "40px" }} />
        </Button>
      </Box>

      {/* /////////////////////////// youtube video  */}
      <Box sx={{ display: "flex", marginTop: "25px", flexDirection: "column" }}>
        <Typography component="h4" sx={{ fontWeight: "bold", color: "white" }}>
          {tournamentData.title} Top 10 Goals
        </Typography>
        {/* <Box
          sx={{
            width: { xs: "100%", md: "30%" },
            maxWidth: { xs: "unset", md: "300px" },
            height: "250px",
          }}
        >
          <ReactPlayer
            url={tournamentData.yt_video}
            controls={true}
            width="100%"
            height="100%"
            config={{
              file: {
                attributes: {
                  poster: tournamentData.yt_Video_thumb,
                },
              },
            }}
          />
        </Box> */}
      </Box>
    </Box>
  );
};

export default Info;
